/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGifReportParams } from "../../services/RedGifsService";
import { IAppAction } from "../appAction";

export const videoActions = {
  REPORT_GIF_BY_ID: "REPORT_GIF_BY_ID",
  REPORT_GIF_BY_ID_SUCCESS: "REPORT_GIF_BY_ID_SUCCESS",
  REPORT_GIF_BY_ID_ERROR: "REPORT_GIF_BY_ID_ERROR",
  ADD_TO_QUEUE: "ADD_TO_QUEUE",
  REMOVE_FROM_QUEUE: "REMOVE_FROM_QUEUE",
};

export const reportGifById = (params: IGifReportParams): IAppAction => ({
  type: videoActions.REPORT_GIF_BY_ID,
  payload: params
});

export const reportGifByIdSuccess = (payload: any): IAppAction => ({
  type: videoActions.REPORT_GIF_BY_ID_SUCCESS,
  payload
});

export const reportGifByIdError = (error: Error): IAppAction => ({
  type: videoActions.REPORT_GIF_BY_ID_ERROR,
  payload: error
});

export const addToQueue = (payload: string): IAppAction => ({
  type: videoActions.ADD_TO_QUEUE,
  payload
});

export const removeFromQueue = (payload: string): IAppAction => ({
  type: videoActions.REMOVE_FROM_QUEUE,
  payload
});
